import { createContext, useContext } from 'react';
import type { NavSection } from './workspace-sections';

export type GoToWorkspaceSection = (
  section: NavSection,
  params?: Record<string, string | number | null | undefined>,
  opts?: { workspaceSlug?: string; replace?: boolean },
) => void;

export const WorkspaceNavigationContext = createContext<GoToWorkspaceSection | null>(null);

export function useGoToSection(): GoToWorkspaceSection {
  const goToSection = useContext(WorkspaceNavigationContext);
  if (!goToSection) throw new Error('useGoToSection requires WorkspaceNavigationProvider');
  return goToSection;
}
